"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRpcMethodName = exports.RPC_METHOD_NAMES = exports.RPC_METHODS = void 0;
// Every method from every domain, and the per-method types read back from the definitions.
const gateway_js_1 = require("./gateway.js");
const zigbee_js_1 = require("./zigbee.js");
// A new domain's methods/<domain>.ts is spread in here.
exports.RPC_METHODS = Object.assign(Object.assign({}, gateway_js_1.GATEWAY_METHODS), zigbee_js_1.ZIGBEE_METHODS);
exports.RPC_METHOD_NAMES = Object.keys(exports.RPC_METHODS);
// Own keys only: a method name is untrusted input, and 'toString' must not read as a method.
const isRpcMethodName = (method) => Object.prototype.hasOwnProperty.call(exports.RPC_METHODS, method);
exports.isRpcMethodName = isRpcMethodName;
